module.exports = __webpack_public_path__ + "static/media/IMG_0066.d7dba6b1.jpg";